import * as pdfjsLib from 'pdfjs-dist'

pdfjsLib.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjsLib.version}/build/pdf.worker.min.mjs`

const withTimeout = <T>(promise: Promise<T>, ms: number): Promise<T> => {
	return Promise.race([
		promise,
		new Promise<T>((_, reject) => setTimeout(() => reject(new Error('PDF render timed out')), ms))
	])
}

export const renderPdfToImage = async (data: Uint8Array): Promise<string> => {
	const RENDER_TIMEOUT_MS = 10000
	const pdf = await withTimeout(pdfjsLib.getDocument({ data }).promise, RENDER_TIMEOUT_MS)
	const page = await pdf.getPage(1)
	const scale = 2
	const viewport = page.getViewport({ scale })

	const canvas = document.createElement('canvas')
	canvas.width = viewport.width
	canvas.height = viewport.height

	const context = canvas.getContext('2d')
	if (!context) throw new Error('Could not get canvas 2d context')

	await page.render({ canvas, canvasContext: context, viewport }).promise
	return canvas.toDataURL('image/png')
}
